<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 5px;">
          <v-layout row style="padding: 10px;">
            <v-layout>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md3 style="padding: 15px;">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <!-- <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search"
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>-->
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->
            <v-btn fab dark small color="amber darken-2" @click="getData">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>

            <!-- <add-button @add="openAddDialog"></add-button> -->
            <!-- Dialog for Add, View Edit  -->

            <customize-dialog
              :type="''"
              :title="title"
              action="view"
              color="blue"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container fluid grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <details-container
                      ref="detailsRef"
                      :headers="tripHeaders"
                      :items="tripItems"
                      :data="viewData"
                      @download="openViewTripDialog"
                      @downloadPDF="downloadPDF"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </customize-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="saveTripSummary"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-layout>

          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon
                    class="mr-3"
                  >{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8></v-flex>
            </v-layout>
          </v-container>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="By Company"
                solo
                clearable
              ></v-select>
            </v-flex>
            <v-flex md4>
              <v-select
                v-model="filterSubCompany"
                :items="filterSubCompanies"
                label="By Sub-Company"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-divider></v-divider>
        </v-container>

        <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
              >{{ header.text.toUpperCase() }}</th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1}}</td>
            <td class="text-xs-left text-uppercase">{{ props.item.control_no }}</td>
            <!-- <td class="text-xs-left">{{ props.item.vehicle_no }}</td> -->
            <td class="text-xs-left">{{ $dateFormat(props.item.date, "YYYY-MM-DD") }}</td>
            <td class="text-xs-left">{{ $dateFormat(props.item.date, "HH:mm") }}</td>
            <td
              class="text-xs-left text-uppercase"
            >{{ props.item.company ? props.item.company : "--" }}</td>
            <td
              class="text-xs-left text-uppercase"
            >{{ props.item.sub_company ? props.item.sub_company : "--" }}</td>
            <td class="text-no-wrap text-xs-center">
              <view-button @view="openViewDialog(props.item)"></view-button>
              <!-- <delete-button @delete="openDeleteDialog(props.item)"></delete-button> -->
            </td>
          </template>
        </v-data-table>
        <!-- <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
        </v-container>-->
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/TripManifestDetailsContainer";
import TripSummaryDialog from "@/components/dialog/TripReportDialog";
import JsPdf from "jspdf";
import "jspdf-autotable";
const now = new Date();
import XLSX from "xlsx";

export default {
  components: {
    DetailsContainer,
    TripSummaryDialog
  },
  data() {
    return {
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,

      title: "Trip Manifest",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Control No.",
          align: "left",
          value: "control_no",
          sortable: true
        },
        {
          text: "Date",
          align: "left",
          value: "date",
          sortable: false
        },
        {
          text: "Time",
          align: "left",
          value: "date",
          sortable: false
        },
        {
          text: "Company",
          align: "left",
          value: "company_id",
          sortable: false
        },
        {
          text: "Sub-Company",
          align: "left",
          value: "sub_company_id",
          sortable: false
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      tripHeaders: [
        { text: "Trip No.", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Dispatch Date",
          align: "center",
          value: "date",
          sortable: false
        },
        {
          text: "Dispatch Time",
          align: "center",
          value: "date",
          sortable: false
        },
        {
          text: "Arrival Date",
          align: "center",
          value: "date",
          sortable: false
        },
        {
          text: "Arrival Time",
          align: "center",
          value: "date",
          sortable: false
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      items: [],
      tripItems: [],
      data: {},
      employeeItems: [],
      queryParams: {
        search: "",
        company_id: null,
        sub_company_id: null,
        date_to: null,
        date_from: null
      },
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},
      viewUser: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 }
      ],
      selected: [],
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      positions: [
        {
          text: "ADMIN",
          value: "admin"
        },
        {
          text: "CASHIER",
          value: "cashier"
        },
        {
          text: "CONDUCTOR",
          value: "conductor"
        },
        {
          text: "DISPATCHER",
          value: "dispatcher"
        },
        {
          text: "DRIVER",
          value: "driver"
        },
        {
          text: "INSPECTOR",
          value: "inspector"
        },
        {
          text: "GAS MAN",
          value: "gas man"
        },
        {
          text: "SUPERVISOR",
          value: "supervisor"
        }
      ],
      valid: true,
      rules: {
        required: value => !!value || "This field is required."
      },
      subcompanies: [],
      accessCards: [],
      openDate: null,
      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      company_id: null,
      sub_company_id: null
    };
  },
  created: function() {
    // this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    }
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.queryParams.sub_company_id = null;
        this.setFilterSubCompanies();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.queryParams.sub_company_id = null;
      }
    },
    filterSubCompany: async function() {
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = this.filterSubCompany;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = null;
      }
    }
  },
  methods: {
    search(data) {
      console.log(data);
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      try {
        // Query Data
        let response = (await Services.getTripManifests(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async getProjects() {
      // Start Loading
      this.assignItems = [];
      const response = this.$store.state.subcompany;

      this.assignItems = response.projects;
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getTripManifest(id);

        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },
    async setTripTicketData(id) {
      var data = {};

      try {
        const response = await Services.getTripManifestTickets(id);

        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },
    async setUser(id) {
      var data = {};

      try {
        const response = await Services.getUser(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },
    async setEmployees() {
      this.employeeItems = [];
      this.employeeItems = (await Services.getUnassignedEmployees({
        company_id: this.$store.state.company.id,
        sub_company_id: this.$store.state.subcompany.id,
        project_id: this.$store.state.project.id
      })).data;
    },
    async setAccessCards() {
      this.accessCards = [];

      const response = await Services.getAccessCard(
        this.viewData.access_card_id
      );
      const data = await response.data;

      this.accessCards.push({
        text: data.embedded_id.toUpperCase(),
        value: data.id
      });
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const response = await Services.getSubCompany(
        this.viewData.employed_sub_company_id
      );
      const data = await response.data;

      this.subcompanies.push({
        text: data.name.toUpperCase(),
        value: data.id
      });
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setEmployees();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.viewData = {};

      this.data.id = data.id;

      this.dialogLoading = true;

      this.dialogStatus = true;

      const view = await this.setData(data.id);

      if (view) {
        if (view.data) {
          this.viewData = view.data.details;
          this.tripItems = view.data.trips;
        }
      }

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewTripDialog(data) {
      const view = await this.setTripTicketData(data.id);

      if (!view) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection"
        });

        return;
      }

      const wscols = [];
      const dataToDownload = [];
      const header = ["", "Name", "Card Number", "Address", "Contact Number"];
      const items = view.data.contacts;
      const details = view.data.details;

      for (let i = 0; i < header.length + 7; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 30 });
        wscols.push({ wch: 40 });
        wscols.push({ wch: 20 });
      }

      dataToDownload.push(["", "", "", "", ""]);
      dataToDownload.push([
        "",
        "",
        details.company ? details.company.toUpperCase() : "",
        "",
        ""
      ]);
      dataToDownload.push(["", "", "", "", ""]);
      dataToDownload.push(["", "", "", "", ""]);

      dataToDownload.push([
        "",
        "Control No:",
        details.control_no ? details.control_no.toUpperCase() : "",
        "Vehicle No:",
        details.vehicle_no ? details.vehicle_no.toUpperCase() : ""
      ]);

      dataToDownload.push([
        "",
        "Trip No:",
        `${details.trip_no}`,
        "Route:",
        details.route ? details.route.toUpperCase() : ""
      ]);

      dataToDownload.push([
        "",
        "Date:",
        details.date ? this.$dateFormat(details.date, "YYYY-MM-DD") : "",
        "Time:",
        details.date ? this.$dateFormat(details.date, "HH:mm-ss") : ""
      ]);

      dataToDownload.push(["", "", "", "", ""]);

      dataToDownload.push(header);

      items.map(item => {
        const theItem = [];

        theItem.push("");
        theItem.push(`${item.lastname}, ${item.firstname} ${item.middlename}`);
        theItem.push(item.card_no);
        theItem.push(`${item.street} ${item.barangay} ${item.city}`);
        theItem.push(item.contactno);

        dataToDownload.push(theItem);
      });

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      const merge = [{ s: { r: 1, c: 2 }, e: { r: 1, c: 3 } }];
      ws["!merges"] = merge;
      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports"
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"]
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf"
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);
      // let test = JSON.parse(this.viewData.phone_no);
      // console.log(test);
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveTripSummary() {
      this.confirmLoading = true;

      try {
        const response = await Services.closeEndOfDay(this.data.id);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeConfirmDialog();
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "EOD has been saved!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = false;
    },
    numberWithCommas(numC) {
      if (numC === undefined || numC === "") {
        return "";
      }
      numC = parseFloat(numC).toFixed(2);
      return numC.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          id: data.id,
          first_name: data.first_name,
          middle_name: data.middle_name,
          last_name: data.last_name,
          email: data.email,
          gender: data.gender,
          nationality: data.nationality,
          birth_date: data.birth_date,
          civil_status: data.civil_status,
          unit_no: data.unit_no,
          house_no: data.house_no,
          street: data.street,
          subdivision: data.subdivision,
          barangay: data.barangay,
          city: data.city,
          province: data.province,
          zip_code: data.zip_code,
          issued_company_id: data.issued_company_id,
          access_card_id: data.access_card_id
        };
      console.log(body);
      try {
        const response = await Services.editEmployee(body);
        console.log(response.status);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Employee has been updated!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteEmployee(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Employee has been deleted!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      if (this.dialogLoading === false) {
        // this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;

      // this.viewData = {};
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.employeeItems.slice();
    },
    refreshTable() {
      this.$refs.searchRef.clear();
      this.filterPosition = null;
      this.getData();
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    async setFilterCompanies() {
      this.filterCompanies = [];
      const items = (await Services.getCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };
        this.filterCompanies.push(data);
      }
    },
    async setFilterSubCompanies() {
      this.filterSubCompanies = [];
      const items = (await Services.getSubCompanies({
        company_id: this.filterCompany
      })).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };
        this.filterSubCompanies.push(data);
      }
    },
    async downloadPDF(data) {
      const view = await this.setTripTicketData(data.id);

      if (!view) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection"
        });

        return;
      }

      const items = view.data.contacts;
      const details = view.data.details;

      let doc = new JsPdf("l", "pt", "a4");

      doc.setFontSize(15);
      doc.setFontType("bold");
      doc.text(details.company ? details.company.toUpperCase() : "", 410, 40, {
        align: "center"
      });

      doc.setLineWidth(2);
      doc.rect(10, 60, 820, 65);

      doc.setLineWidth(2);
      doc.line(10, 82, 830, 82);
      doc.line(10, 102, 830, 102);

      doc.setLineWidth(2);
      doc.line(400, 60, 400, 165); // vertical line

      doc.setLineWidth(2);
      doc.line(220, 60, 220, 165); // vertical line
      doc.line(700, 60, 700, 165); // vertical line

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Control No.:", 15, 75, {
        align: "left"
      });
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(
        details.control_no ? details.control_no.toUpperCase() : "",
        225,
        75,
        {
          align: "left"
        }
      );
      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Trip No.:", 15, 95, {
        align: "left"
      });
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(details.trip_no + "", 225, 95, {
        align: "left"
      });
      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Date:", 15, 118, {
        align: "left"
      });
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(
        details.date ? this.$dateFormat(details.date, "YYYY-MM-DD") : "",
        225,
        118,
        {
          align: "left"
        }
      );
      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Vehicle No.:", 405, 75, {
        align: "left"
      });
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(
        details.vehicle_no ? details.vehicle_no.toUpperCase() : "",
        705,
        75,
        {
          align: "left"
        }
      );
      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Route:", 405, 95, {
        align: "left"
      });
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(details.route ? details.route.toUpperCase() : "", 705, 95, {
        align: "left"
      });
      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Time:", 405, 118, {
        align: "left"
      });
      doc.setFontSize(9);
      doc.setFontType("bold");
      doc.text(
        details.date ? this.$dateFormat(details.date, "HH:mm-ss") : "",
        705,
        118,
        {
          align: "left"
        }
      );

      doc.setLineWidth(2);
      doc.rect(10, 125, 820, 20);
      doc.rect(10, 145, 820, 20);

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Name", 15, 159, {
        align: "left"
      });

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Card Number", 225, 159, {
        align: "left"
      });

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Address", 405, 159, {
        align: "left"
      });

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.text("Contact Number", 705, 159, {
        align: "left"
      });

      for (let i = 0; i < items.length; i++) {
        let currentYRec = 165;
        let currentYText = 177;
        let toAddY = i * 20;
        let theFinalYRec = currentYRec + toAddY;
        let theFinalYText = currentYText + toAddY;

        doc.setLineWidth(2);
        doc.rect(10, theFinalYRec, 210, 20);
        doc.rect(220, theFinalYRec, 180, 20);
        doc.rect(400, theFinalYRec, 300, 20);
        doc.rect(700, theFinalYRec, 130, 20);

        doc.setFontSize(9);
        doc.setFontType("bold");
        doc.text(
          items[i].lastname +
            ", " +
            items[i].firstname +
            " " +
            items[i].middlename,
          15,
          theFinalYText,
          {
            align: "left"
          }
        );
        doc.text(items[i].card_no, 225, theFinalYText, {
          align: "left"
        });
        doc.text(
          items[i].street + " " + items[i].barangay + " " + items[i].city,
          405,
          theFinalYText,
          {
            align: "left"
          }
        );
        doc.text(items[i].contactno, 705, theFinalYText, {
          align: "left"
        });
      }

      doc.save(this.title + ".pdf");
    }
  }
};
</script>

<style scoped>
</style>